import React, { Component } from 'react';

import cn from 'client/utils/cn';

import './index.css';

const b = cn('doc');

interface Props {
    theme?: 'gray';
    link?: string;
    name?: string;
    format?: string;
    size?: string;
    textUppercase?: boolean;
}

export default class Doc extends Component<Props> {
    render(): React.ReactNode {
        const { link, name, format, theme } = this.props;

        if (!link) {
            return null;
        }

        return (
            <a href={link} className={b({ theme })} target="_blank" rel="noopener noreferrer">
                <i className={b('icon', { 'format': format || 'pdf' })} />

                <span className={b('inner')}>
                    <span className={b('name')}>{name}</span>

                    {(format && !name) && (
                        <span className={b('info')}>
                            {format && (
                                <span className={b('format')}>{format}</span>
                            )}
                        </span>
                    )}
                </span>
            </a>
        );
    }
}
